import { formatCurrency } from '@utils/price-formatter/price-formatter';

export const getCurrencySymbol = (currency: string) => {
  const formattedPrice = formatCurrency({
    currency,
    number: 0,
  });
  if (!formattedPrice) throw new Error(`Invalid currency: ${currency}`);
  return formattedPrice.replace(/[\d.,\s]/g, '');
};
